import React from "react";
import { View } from "react-native";
import { scale, verticalScale } from "../../utils/scale";
import Text from "@components/AppText";
export class LastTimeItem extends React.Component {
  render() {
    return (
      <View
        style={[
          {
            width: scale(162),
            marginHorizontal: scale(10),
            height: verticalScale(70),
            borderRadius: 9,
            backgroundColor: "#fff",
            justifyContent: "center",
            alignItems: "flex-start",
            paddingHorizontal: 10,
          },
          this.props.containerStyle,
        ]}
      >
        <Text
          style={[
            { fontSize: scale(12), color: "rgba(0,0,0,.5)" },
            this.props.headingStyle,
          ]}
        >
          {this.props.title}
        </Text>
        <Text
          bold
          style={[
            {
              fontSize: scale(14),
              marginTop: verticalScale(6),
              color: "rgba(0,0,0,.86)",
            },
            this.props.descriptionStyle,
          ]}
        >
          {this.props.description}
        </Text>
      </View>
    );
  }
}
